import { MenuItem, Typography } from "@material-ui/core";
import React from "react";
import {Link} from "gatsby"

const NavbarLinkList = ({ data }) => {
  return (
    <div style={{ display: "flex", flexDirection: "row", marginLeft: "16" }}>
      {data?.map((item) => (
        <MenuItem button key={item.text} component={Link} to={item.url}>
          <Typography>{item.text}</Typography>
        </MenuItem>
      ))}
    </div>
  );
};

export default NavbarLinkList;
